import { render, staticRenderFns } from "./FootprintBungeMoinhoTrigo.vue?vue&type=template&id=20e1c2c6&lang=pug"
import script from "./FootprintBungeMoinhoTrigo.vue?vue&type=script&lang=js"
export * from "./FootprintBungeMoinhoTrigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports